import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import Accessibility from 'highcharts/modules/accessibility'
import Sankey from 'highcharts/modules/sankey'
import Stock from 'highcharts/modules/stock'
import HighchartsVue from 'highcharts-vue'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(nuxtApp => {
  Stock(Highcharts) // highstock
  Sankey(Highcharts) // sankey chart
  HighchartsMore(Highcharts) // arearange chart
  Accessibility(Highcharts) // scatter chart

  Highcharts.setOptions({
    lang: {
      thousandsSep: ',',
      numericSymbols: [ 'K', 'M', 'B', 'T', 'P', 'E' ],
    },
    credits: { enabled: false },
    chart: {
      style: {
        fontFamily: '\'Inter\', \'Noto Sans KR\', sans-serif',
      },
    },
  })

  nuxtApp.vueApp.use(HighchartsVue as any)
})
